'use client';

import React from 'react';
import {
  Container as ChakraContainer,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';

interface AuthContainerProps {
  children: React.ReactNode;
  logo: React.ReactNode;
  title?: string;
  description?: React.ReactNode;
  view: string;
  hideHeader?: boolean;
}

const AuthContainer = ({
  children,
  logo,
  title,
  description,
  view,
  hideHeader = false,
}: AuthContainerProps) => {
  const i18n = useTranslations('Auth');

  return (
    <ChakraContainer
      maxW="md"
      py={{ mobile: '8', tablet: '8' }}
      px={{ mobile: '10', tablet: '10' }}
      bg="white"
      boxShadow={{ base: 'xl', sm: 'xl' }}
      borderRadius={{ base: 'lg', sm: 'lg' }}
    >
      <Stack spacing="8">
        <Stack spacing="6" align="center">
          {logo}
          {!hideHeader && (
            <Stack spacing="3" textAlign="center">
              <Heading size="lg">{title || i18n(`${view}.title`)}</Heading>
              <Text color="muted">
                {description || i18n(`${view}.description`)}
              </Text>
            </Stack>
          )}
        </Stack>
        <Stack spacing="2">{children}</Stack>
      </Stack>
    </ChakraContainer>
  );
};

export default AuthContainer;
